import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@shared/api/client';
import { DateRange } from '@shared/components/DateRangeFilter';

export interface LoyaltyAnalyticsDto {
  validCount: number;
  invalidCount: number;
  inReviewCount: number;
  pendingCount: number;
  topUploader: { userId: string; name: string; count: number } | null;
  maxReceipt: { userId: string; name: string; amount: number; date: string } | null;
  avgMonthly: number;
  daily: Array<{ date: string; totalAmount: number; count: number }>;
}

export function useAnalyticsLoyalty(range: DateRange) {
  const [from, to] = range;
  return useQuery({
    queryKey: ['analytics', 'loyalty', from.toISOString(), to.toISOString()],
    queryFn: async () => {
      const res = await apiClient.get<LoyaltyAnalyticsDto>('/analytics/loyalty', {
        params: { from: from.toISOString(), to: to.toISOString() },
      });
      return res.data;
    },
  });
}
